import { AppShell } from '../components/AppShell';
import { BRAND } from '../config/brand';
import { TERMS_VERSION, TERMS_LAST_UPDATED } from '../data/legal';

export function Terms() {
  return (
    <AppShell title="Terms & Conditions" back="/settings">
      <div className="card" style={{ marginBottom: 12 }}>
        <p style={{ margin: 0, color: 'var(--ink-soft)', fontSize: 13 }}>
          Version {TERMS_VERSION} · Last updated {TERMS_LAST_UPDATED}.
        </p>
        <p style={{ margin: '8px 0 0', color: 'var(--ink-soft)', fontSize: 13 }}>
          This is a plain-English summary. The full Terms of Service are at{' '}
          <a href="https://safeandsorted.com/terms.html" target="_blank" rel="noopener noreferrer">
            safeandsorted.com/terms.html
          </a>{' '}
          and form part of your subscription agreement.
        </p>
      </div>

      <h3 className="section-title">Who provides this service</h3>
      <div className="card">
        <p style={{ marginBottom: 0 }}>
          {BRAND.name} is operated by <strong>{BRAND.legalEntity}</strong> (company no. {BRAND.companyNumber}),
          a company registered in {BRAND.companyJurisdiction}. Registered office: {BRAND.registeredOffice}.
        </p>
      </div>

      <h3 className="section-title">Use of this app</h3>
      <div className="card">
        <p>
          {BRAND.name} is a digital construction Health & Safety record-keeping tool. It does not
          replace professional judgement, on-site inspection, or compliance with applicable legislation.
        </p>
        <p>
          You retain full ownership of the data you enter. {BRAND.legalEntity} stores it on UK / EU
          infrastructure on your behalf and provides export tools so you can take it elsewhere at any time.
        </p>
      </div>

      <h3 className="section-title">DRAFT RAMS templates</h3>
      <div className="card">
        <p>
          The DRAFT RAMS feature provides starter templates intended to save time. They are
          <strong> not finished, ready-to-use RAMS</strong>. Every template must be reviewed,
          amended, and verified for the specific site, task, conditions, contractor and people
          involved before it is relied upon as an operative document.
        </p>
        <p style={{ marginBottom: 0 }}>
          The following disclaimer appears on every generated RAMS PDF:
        </p>
      </div>

      <div className="card" style={{ background: '#FFF8E5', borderColor: 'var(--warn)', borderLeftWidth: 4 }}>
        <p style={{ margin: 0, fontWeight: 600 }}>DISCLAIMER</p>
        <p>
          This document is a draft template provided for guidance purposes only and does not
          constitute professional health and safety advice.
        </p>
        <p>
          The user is solely responsible for ensuring that all risk assessments and method
          statements are suitable, sufficient, site-specific, and compliant with applicable
          legislation including the Health and Safety at Work etc. Act 1974 and CDM Regulations 2015.
        </p>
        <p>
          Users must review, amend, and verify all content prior to use.
        </p>
        <p style={{ marginBottom: 0 }}>
          <strong>{BRAND.legalEntity}</strong> (trading as {BRAND.name}) accepts no liability for
          loss, injury, damage, prosecution, or non-compliance arising from use of this template.
        </p>
      </div>

      <h3 className="section-title">Liability</h3>
      <div className="card">
        <p style={{ marginBottom: 0 }}>
          To the fullest extent permitted by law, {BRAND.legalEntity} accepts no liability for loss,
          injury, damage, prosecution, or non-compliance arising from any use of this app or
          the documents it generates. Health and Safety responsibility on a construction site
          rests with the duty-holders defined under CDM 2015.
        </p>
      </div>

      <h3 className="section-title">Data & privacy</h3>
      <div className="card">
        <p style={{ marginBottom: 0 }}>
          Personal data (sign-in records, signatures, photos) is held to support legitimate
          construction H&S record-keeping under CDM 2015 and the Health and Safety at Work etc.
          Act 1974. A full Privacy Policy will be published before public launch.
        </p>
      </div>

      <h3 className="section-title">Account & termination</h3>
      <div className="card">
        <p style={{ marginBottom: 0 }}>
          You can request export of all your data at any time. Account closure removes access
          from the app; underlying records are retained per H&S retention norms (typically up
          to 7 years for sign-in / inspection records, longer for accident-related records).
        </p>
      </div>

      <h3 className="section-title">Governing law</h3>
      <div className="card">
        <p style={{ marginBottom: 0 }}>
          These terms are governed by the law of England and Wales.
        </p>
      </div>

      <div className="card" style={{ marginTop: 16, background: 'var(--bg-soft, #FAF7F2)' }}>
        <p style={{ margin: 0, fontSize: 13, color: 'var(--ink-soft)' }}>
          <strong>{BRAND.legalEntity}</strong><br />
          Company no. {BRAND.companyNumber} · Registered in {BRAND.companyJurisdiction}<br />
          Registered office: {BRAND.registeredOffice}
        </p>
      </div>
    </AppShell>
  );
}
